import { Grid, Typography, makeStyles } from '@material-ui/core';
import { Add, ChevronRight, KeyboardArrowDown } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import FileIcon from '../../assets/FileIcon';
import ZeroState from './ZeroState';
import EditIcon2 from '../../assets/EditIcon2';
import ConfirmationDialog from './ConfirmationDialog';
import DeleteIcon from '../../assets/DeleteIcon';
import { ErrorToast } from '../utils/Utils';

const useStyle = makeStyles({
  questionBox: {
    height: '68vh',
    overflowY: 'auto',
    background: '#F2F4F7',
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 20px',
  },
  add: {
    width: '40px',
    height: '40px',
    color: 'white',
    background: '#622FEE',
    border: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    cursor: 'pointer',
  },
  heading: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#10182B',
  },
  qeustionsCat: {
    marginTop: '15px',
  },
  questionWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '10px',
  },
  qeustion: {
    width: '92%',
    background: '#fff',
    padding: '10px',
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '15px',
    cursor: 'pointer',
  },
  box: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  catTitle: {
    color: '#10182B',
    fontSize: '16px',
    fontWeight: '600',
    marginTop: '20px',
  },
});

export function QuestionList({
  setIsAddQuestion,
  questions,
  setQeustions,
  setIsEdit,
  setSelectedIndex,
  categories,
  info,
  calledFrom,
  journeys,
}) {
  const classes = useStyle();
  const [showAns, setShowAns] = useState(null);
  const [delIndx, setDelIndx] = useState(null);
  const [isConfirmDelete, setIsConfirmDelete] = useState(false);
  const [categorizedQuestions, setCategorizedQuestions] = useState([]);

  useEffect(() => {
    const allQeustions = [...questions];
    if (allQeustions && allQeustions.length > 0) {
      const temp = [];

      if (calledFrom === 'certificate') {
        allQeustions.forEach((question, indx) => {
          const categoryIndex = temp.findIndex((cat) => cat.category === question.questionCategoryId);

          if (categoryIndex !== -1) {
            const que = { ...question };
            que.index = indx;
            temp[categoryIndex].questions.push(que);
          } else {
            const que = { ...question };
            que.index = indx;
            temp.push({
              category: question.questionCategoryId,
              questions: [que],
            });
          }
        });
      }

      if (calledFrom === 'collectionAssesment' || calledFrom === 'collectionExam') {
        allQeustions.forEach((question, indx) => {
          const journeyIndx = temp.findIndex((item) => item.category === question.journeyId);

          if (journeyIndx !== -1) {
            const que = { ...question };
            que.index = indx;
            temp[journeyIndx].questions.push(que);
          } else {
            const que = { ...question };
            que.index = indx;
            temp.push({
              category: question.journeyId,
              questions: [que],
            });
          }
        });
      }

      setCategorizedQuestions(temp);
    }
  }, [questions]);

  const getQeustionCatTitle = (id) => {
    let data = [];
    if (calledFrom === 'certificate') {
      data = categories;
    } else if (calledFrom === 'collectionAssesment' || calledFrom === 'collectionExam') {
      data = journeys;
    }
    const temp = data?.filter((d) => d.id === id) || [];
    return temp.length > 0 ? temp[0].title : '';
  };

  const handleQuestionRemove = (indx) => {
    const temp = [...questions];
    temp.splice(indx, 1);
    setQeustions(temp);
    setIsConfirmDelete(false);
  };

  const handleEditQuestion = (index) => {
    setIsAddQuestion(true);
    setIsEdit(true);
    setSelectedIndex(index);
  };

  const handlDelConfirm = (indx) => {
    setDelIndx(indx);
    setIsConfirmDelete(true);
  };

  const onDelete = (index) => {
    if (info?.editWarning) {
      ErrorToast('Certification is in active assignment, this question cannot be deleted.');
    } else {
      handlDelConfirm(index);
    }
  };

  return (
    <Grid className={classes.questionBox}>
      <Grid style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Grid>
          {calledFrom === 'collectionAssesment' || calledFrom === 'collectionExam' ? (
            <Typography className={classes.heading}>{`Question Bank (${questions?.length || 0})`}</Typography>
          ) : (
            <Typography className={classes.heading}>{`Questions for Exam (${questions?.length || 0})`}</Typography>
          )}
        </Grid>
        <Grid
          className={classes.add}
          onClick={() => {
            if (info?.editWarning) {
              ErrorToast(info.editWarning);
            } else {
              setIsAddQuestion(true);
            }
          }}
        >
          <Add />
        </Grid>
      </Grid>
      {calledFrom === 'collectionAssesment' || calledFrom === 'collectionExam' ? (
        <Grid>
          <Typography style={{ color: '#667085', fontSize: '12px' }}>
            Note: Add at least 1 question from each journey
          </Typography>
        </Grid>
      ) : null}

      {questions?.length > 0 ? (
        <Grid className={classes.questions}>
          {categorizedQuestions.map((cat) => (
            <Grid className={classes.qeustionsCat} key={cat.category}>
              <Typography className={classes.catTitle}>
                {getQeustionCatTitle(cat.category) || 'Deleted Journey'}
              </Typography>
              {cat.questions?.map((q) => (
                <Grid className={classes.questionWrapper} key={q.index}>
                  <Grid className={classes.qeustion} onClick={() => setShowAns(q.index)}>
                    <Grid className={classes.box}>
                      <Grid style={{ display: 'flex', alignItems: 'center' }}>
                        <Typography style={{ cursor: 'pointer' }}>
                          {showAns === q.index ? <KeyboardArrowDown /> : <ChevronRight />}
                        </Typography>
                        <Typography style={{ wordBreak: 'break-word' }}>{q.title}</Typography>
                      </Grid>

                      {showAns === q.index && (
                        <Typography
                          style={{ marginLeft: '5px', color: '#667085', fontSize: '16px', wordBreak: 'break-word' }}
                        >
                          Answer:
                          {q.options
                            ?.filter((op) => op.isAnswer)
                            ?.map((op, index, array) => (
                              <span style={{ marginLeft: '7px', color: '#667085', fontSize: '16px' }}>
                                {op.title}
                                {index !== array.length - 1 && ','}
                              </span>
                            ))}
                        </Typography>
                      )}
                    </Grid>

                    <Grid
                      onClick={(e) => {
                        e.stopPropagation();
                        if (info?.editWarning) {
                          ErrorToast(info.editWarning);
                        } else {
                          handleEditQuestion(q.index);
                        }
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <EditIcon2 />
                    </Grid>
                  </Grid>
                  <Grid className={classes.cancel}>
                    {questions?.length > 1 ? (
                      <CloseIcon
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          onDelete(q.index);
                        }}
                      />
                    ) : (
                      <CloseIcon style={{ visibility: 'hidden' }} />
                    )}
                  </Grid>
                </Grid>
              ))}
            </Grid>
          ))}
        </Grid>
      ) : (
        <Grid className={classes.questions}>
          <ZeroState
            Icon={FileIcon}
            title="You don’t have any questions added so far."
            text="Add your first question now."
            style={{ paddingBottom: '100px', paddingTop: '30px' }}
            cardWidth="100%"
            btnText="Add Question"
            btnAction={() => setIsAddQuestion(true)}
          />
        </Grid>
      )}

      <ConfirmationDialog
        title="Are you sure you want to delete this Question?"
        subText="Once you delete it, you will not be able to recover this question."
        onClose={setIsConfirmDelete}
        isOpen={isConfirmDelete}
        confirmFn={() => handleQuestionRemove(delIndx)}
        disagreeText="Cancel"
        agreeText="Delete"
        Icon={DeleteIcon}
        width="500px"
        height="250px"
      />
    </Grid>
  );
}
